<template>
  <div class="dashboard">
    <aside class="sidebar" :class="{ collapsed: sidebarCollapsed }">
      <div class="sidebar-header">
        <div class="logo" @click="$router.push('/dashboard')">
          <i class="fas fa-graduation-cap"></i>
          <span v-show="!sidebarCollapsed">智慧迎新</span>
        </div>
        <button class="toggle-btn" @click="sidebarCollapsed = !sidebarCollapsed">
          <i :class="sidebarCollapsed ? 'fas fa-chevron-right' : 'fas fa-chevron-left'"></i>
        </button>
      </div>
      <nav class="sidebar-nav">
        <a href="#" @click.prevent="$router.push('/dashboard')" :class="{ active: $route.path === '/dashboard' }">
          <i class="fas fa-tachometer-alt"></i>
          <span v-show="!sidebarCollapsed">仪表盘</span>
        </a>
        <a href="#" @click.prevent="$router.push('/tasks')" :class="{ active: $route.path === '/tasks' }">
          <i class="fas fa-tasks"></i>
          <span v-show="!sidebarCollapsed">我的任务</span>
        </a>
        <a href="#" @click.prevent="$router.push('/mall')" :class="{ active: $route.path === '/mall' }">
          <i class="fas fa-store"></i>
          <span v-show="!sidebarCollapsed">积分商城</span>
        </a>
        <a href="#" @click.prevent="openProfile">
          <i class="fas fa-user-circle"></i>
          <span v-show="!sidebarCollapsed">个人资料</span>
        </a>
      </nav>
      <div class="sidebar-footer">
        <button @click="logout" class="logout-btn">
          <i class="fas fa-sign-out-alt"></i>
          <span v-show="!sidebarCollapsed">退出登录</span>
        </button>
      </div>
    </aside>

    <main class="main-content">
      <header class="top-bar">
        <div class="welcome">
          <h2>欢迎回来，{{ userInfo.username }}</h2>
          <p>愿你今天收获满满 ✨</p>
        </div>
        <div class="user-info">
          <div class="points-badge">
            <i class="fas fa-star"></i>
            <span>{{ points }} 积分</span>
          </div>
          <div class="avatar">
            <i class="fas fa-user-circle"></i>
          </div>
        </div>
      </header>

      <!-- 统计卡片 -->
      <div class="stats-grid">
        <div class="stat-card">
          <div class="stat-icon">
            <i class="fas fa-check-circle"></i>
          </div>
          <div class="stat-info">
            <h3>{{ completedTasks }}</h3>
            <p>已完成任务</p>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon">
            <i class="fas fa-list-ul"></i>
          </div>
          <div class="stat-info">
            <h3>{{ totalTasks }}</h3>
            <p>总任务数</p>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon">
            <i class="fas fa-chart-line"></i>
          </div>
          <div class="stat-info">
            <h3>{{ taskProgress }}%</h3>
            <p>完成进度</p>
          </div>
        </div>
      </div>

      <!-- 近期任务 -->
      <div class="tasks-section">
        <div class="section-header">
          <h3><i class="fas fa-clock"></i> 近期任务</h3>
          <button @click="goToTasks" class="view-all">查看全部 →</button>
        </div>
        <div class="task-list">
          <div v-for="task in recentTasks" :key="task.id" class="task-item">
            <div class="task-info">
              <div class="task-name">{{ task.name }}</div>
              <div class="task-points">+{{ task.points }} 积分</div>
            </div>
            <div class="task-actions">
              <span class="task-status" :data-status="task.status">
                {{ task.status }}
              </span>
              <button
                v-if="task.status === '进行中'"
                @click="completeTaskFromDashboard(task)"
                class="complete-btn"
              >
                完成
              </button>
              <button
                v-else-if="task.status === '未开始'"
                @click="startTaskFromDashboard(task)"
                class="start-btn"
              >
                开始
              </button>
              <span v-else class="done-badge">✓</span>
            </div>
          </div>
        </div>
      </div>
    </main>

    <!-- 编辑个人信息弹窗 -->
    <div v-if="editProfileDialog" class="modal-overlay" @click="editProfileDialog = false">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>编辑个人信息</h3>
          <button @click="editProfileDialog = false" class="close-btn">×</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>用户名</label>
            <input v-model="editForm.username" disabled>
          </div>
          <div class="form-group">
            <label>邮箱</label>
            <input v-model="editForm.email" type="email">
          </div>
          <div class="form-group">
            <label>手机号</label>
            <input v-model="editForm.phone" type="tel">
          </div>
        </div>
        <div class="modal-footer">
          <button @click="editProfileDialog = false" class="cancel-btn">取消</button>
          <button @click="saveProfile" class="save-btn">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserDashboard',
  data() {
    return {
      sidebarCollapsed: false,
      activeMenu: 'dashboard',
      userInfo: { id: '', username: '', email: '', phone: '' },
      points: 0,
      completedTasks: 0,
      totalTasks: 0,
      recentTasks: [],
      editProfileDialog: false,
      editForm: { username: '', email: '', phone: '' }
    }
  },
  computed: {
    taskProgress() {
      return this.totalTasks === 0 ? 0 : Math.round((this.completedTasks / this.totalTasks) * 100)
    }
  },
  created() {
    this.loadUserInfo()
    this.loadDashboardData()
  },
  methods: {
    loadUserInfo() {
      const userStr = localStorage.getItem('user')
      if (userStr) {
        this.userInfo = JSON.parse(userStr)
        this.editForm = { ...this.userInfo }
      } else {
        this.$router.push('/login')
      }
    },
    goToMall() {
      this.$router.push('/mall')
    },
    async loadDashboardData() {
      try {
        const token = localStorage.getItem('token')
        const [pointsRes, statsRes, tasksRes] = await Promise.all([
          this.$axios.get('/api/points/my', { headers: { Authorization: `Bearer ${token}` } }),
          this.$axios.get('/api/tasks/stats', { headers: { Authorization: `Bearer ${token}` } }),
          this.$axios.get('/api/tasks/my', { headers: { Authorization: `Bearer ${token}` } })
        ])
        if (pointsRes.data.code === 200) this.points = pointsRes.data.data.points
        if (statsRes.data.code === 200) {
          this.completedTasks = statsRes.data.data.completed
          this.totalTasks = statsRes.data.data.total
        }
        if (tasksRes.data.code === 200) this.recentTasks = tasksRes.data.data.slice(0, 5)
      } catch (error) {
        console.error('加载数据失败', error)
      }
    },
    async startTaskFromDashboard(task) {
      try {
        const token = localStorage.getItem('token')
        const res = await this.$axios.post(`/api/tasks/${task.id}/start`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        })
        if (res.data.code === 200) {
          task.status = '进行中'
          this.$message.success('任务已开始')
          this.loadDashboardData()
        }
      } catch (error) {
        this.$message.error('开始任务失败')
      }
    },
    async completeTaskFromDashboard(task) {
      this.$confirm(`确定完成任务"${task.name}"吗？将获得 ${task.points} 积分！`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      }).then(async () => {
        try {
          const token = localStorage.getItem('token')
          const res = await this.$axios.post(`/api/tasks/${task.id}/complete`, {}, {
            headers: { Authorization: `Bearer ${token}` }
          })
          if (res.data.code === 200) {
            task.status = '已完成'
            this.$message.success(res.data.message)
            this.loadDashboardData()
          }
        } catch (error) {
          this.$message.error('完成任务失败')
        }
      }).catch(() => {})
    },
    goToTasks() {
      this.$router.push('/tasks')
    },
    openProfile() {
      this.editProfileDialog = true
    },
    async saveProfile() {
      try {
        const token = localStorage.getItem('token')
        const res = await this.$axios.put('/api/user/profile',
          { email: this.editForm.email, phone: this.editForm.phone },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        if (res.data.code === 200) {
          this.userInfo = { ...this.editForm }
          localStorage.setItem('user', JSON.stringify(this.userInfo))
          this.editProfileDialog = false
          this.$message.success('保存成功')
        }
      } catch (error) {
        this.$message.error('保存失败')
      }
    },
    logout() {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.dashboard {
  display: flex;
  min-height: 100vh;
  background: #f5f7fb;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 侧边栏 */
.sidebar {
  width: 260px;
  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);
  color: #fff;
  transition: width 0.3s ease;
  display: flex;
  flex-direction: column;
  position: fixed;
  height: 100vh;
  z-index: 100;
}

.sidebar.collapsed {
  width: 70px;
}

.sidebar-header {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.logo i {
  font-size: 28px;
  color: #667eea;
}

.logo span {
  font-size: 18px;
  font-weight: 600;
}

.toggle-btn {
  background: rgba(255,255,255,0.1);
  border: none;
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar-nav {
  flex: 1;
  padding: 20px 0;
}

.sidebar-nav a {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 20px;
  color: rgba(255,255,255,0.7);
  text-decoration: none;
  transition: all 0.3s;
  margin: 4px 12px;
  border-radius: 12px;
}

.sidebar-nav a i {
  width: 20px;
  font-size: 18px;
}

.sidebar-nav a:hover,
.sidebar-nav a.active {
  background: rgba(102, 126, 234, 0.2);
  color: #667eea;
}

.sidebar-footer {
  padding: 20px;
  border-top: 1px solid rgba(255,255,255,0.1);
}

.logout-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(255,255,255,0.05);
  border: none;
  color: rgba(255,255,255,0.7);
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s;
}

.logout-btn:hover {
  background: rgba(220, 53, 69, 0.2);
  color: #dc3545;
}

/* 主内容 */
.main-content {
  flex: 1;
  margin-left: 260px;
  transition: margin-left 0.3s ease;
}

.sidebar.collapsed + .main-content {
  margin-left: 70px;
}

.top-bar {
  background: white;
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}

.welcome h2 {
  font-size: 20px;
  margin-bottom: 4px;
}

.welcome p {
  color: #888;
  font-size: 14px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 20px;
}

.points-badge {
  background: linear-gradient(135deg, #ffd89b, #c7e9fb);
  padding: 8px 16px;
  border-radius: 30px;
  color: #333;
  font-weight: 600;
}

.points-badge i {
  color: #ffc107;
  margin-right: 6px;
}

.avatar i {
  font-size: 40px;
  color: #667eea;
}

/* 统计卡片 */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  padding: 30px;
}

.stat-card {
  background: white;
  border-radius: 20px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 18px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  transition: transform 0.2s, box-shadow 0.2s;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.1);
}

.stat-icon {
  width: 55px;
  height: 55px;
  background: linear-gradient(135deg, #667eea20, #764ba220);
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-icon i {
  font-size: 28px;
  color: #667eea;
}

.stat-info h3 {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 4px;
}

.stat-info p {
  color: #888;
  font-size: 14px;
}

/* 任务列表 */
.tasks-section {
  background: white;
  margin: 0 30px 30px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

.section-header {
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-header h3 i {
  margin-right: 8px;
  color: #667eea;
}

.view-all {
  background: none;
  border: none;
  color: #667eea;
  cursor: pointer;
  font-size: 14px;
}

.task-list {
  padding: 0 24px;
}

.task-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #f0f0f0;
}

.task-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.task-name {
  font-weight: 500;
}

.task-points {
  font-size: 12px;
  color: #ffc107;
}

.task-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.task-status {
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 20px;
}

.task-status[data-status="已完成"] {
  background: #e8f5e9;
  color: #4caf50;
}

.task-status[data-status="进行中"] {
  background: #fff3e0;
  color: #ff9800;
}

.task-status[data-status="未开始"] {
  background: #f5f5f5;
  color: #999;
}

.complete-btn, .start-btn {
  padding: 6px 16px;
  border-radius: 20px;
  border: none;
  cursor: pointer;
  font-size: 13px;
}

.complete-btn {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
}

.start-btn {
  background: #e3f2fd;
  color: #2196f3;
}

.done-badge {
  color: #4caf50;
  font-size: 20px;
  font-weight: bold;
}

/* 弹窗 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 20px;
  width: 90%;
  max-width: 450px;
  animation: modalFade 0.2s ease;
}

@keyframes modalFade {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

.modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #999;
}

.modal-body {
  padding: 24px;
}

.modal-body .form-group {
  margin-bottom: 16px;
}

.modal-body label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
}

.modal-body input {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-sizing: border-box;
}

.modal-footer {
  padding: 16px 24px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.cancel-btn, .save-btn {
  padding: 10px 24px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
}

.cancel-btn {
  background: #f5f5f5;
}

.save-btn {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
}
</style>